








































import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import ShipmentTile from '../components/ShipmentTile.vue'
import '../styles/shipments-to-dealers.css'

interface IShipment {
  accountName: string
  shipToName: string
  shipmentId: number
  trackingNumber: string
  description: string
  shipmentDate: Date
  shipmentMethodUsed: string
}

interface IDbShipment {
  accountName: string
  shipToName: string
  shipmentId: number
  trackingNumber: string
  description: string
  created: Date
  shipmentMethodUsed: string
}

export default Vue.extend({
  components: { ScreenTile, ShipmentTile },
  data: function () {
    return {
      loading: true,
      shipments: [] as IShipment[],
      searchText: '',
      page: 1,
      pageSize: 12,
    }
  },
  mounted: async function () {
    this.shipments = (await (await fetch('/api/shipments')).json()).map(
      (x: IDbShipment) => ({
        accountName: x.accountName,
        shipmentId: x.shipmentId,
        shipToName: x.shipToName ?? '',
        trackingNumber: x.trackingNumber,
        description: x.description ?? '',
        shipmentDate: new Date(x.created),
        shipmentMethodUsed: x.shipmentMethodUsed,
      })
    )
    this.loading = false
  },
  computed: {
    filteredShipments(): IShipment[] {
      return this.shipments.filter((x: IShipment) =>
        x.shipToName.toLowerCase().includes(this.searchText.toLowerCase())
      )
    },
    pagedShipments(): IShipment[] {
      return this.filteredShipments.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      )
    },
    pages(): number {
      return Math.ceil(this.filteredShipments.length / this.pageSize)
    },
  },
  methods: {
    getTrackingUrl(trackingNumber: string, shipmentDate: Date) {
      if (shipmentDate < new Date(2023, 8, 1))
        return `https://www.ups.com/mobile/track?trackingNumber=${trackingNumber}`
      else
        return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`
    },
  },
})
